// extracted by mini-css-extract-plugin
export default {"container":"styles_container__18u0E","toggle":"styles_toggle__eDlu4","active":"styles_active__hOtKw","switch":"styles_switch__syRBP"};